import type { FunctionComponent } from "react";

export const PriceCell: FunctionComponent = ({ children }) => {
  if (!children) {
    return <i>Error</i>;
  }

  return <div>{(children as number).toFixed(2)} €</div>;
};
